import {Component, OnInit} from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { Padron } from "@shared/models/facturacion/Padron";
import { MessageService } from "@shell/message.service";
import { PadronesService } from "@facturacion/padrones.service";

@Component({
  selector: 'app-historial-padrones',
  templateUrl: './historial-padrones.component.html',
  styleUrl: './historial-padrones.component.scss'
})
export class HistorialPadronesComponent implements OnInit{
  esperandoCarga: boolean = true;
  padronesFiltrados: Padron[] = [];
  padronesRecibidos: Padron[] = [];
  padrones: Padron[] = [];
  /** scroll infinito */
  throttle = 500;
  distance = 1;
  page = 1;
  pageSize = 50;
  obteniendoDatosScroll: boolean;

  constructor (private spinner: NgxSpinnerService, private messageService: MessageService, private padronesService: PadronesService){ }

  ngOnInit(){
    this.page = 1;
    this.getPadrones(this.page, false);
  }

  async getPadrones(page: number, isScroll: boolean){
    if(!isScroll) {
      this.handleSpinner(true);
    } else {
      this.mostrarSpinnerScroll();
    }
    try {
      this.padronesRecibidos = await this.padronesService.ObtenerHistorialPadrones(page, this.pageSize);

      if(!isScroll) {
        this.padrones = this.padronesRecibidos;
      } else {
        this.padrones = this.padrones.concat(this.padronesRecibidos);
      }

      for (let i = 0; i < this.padrones.length; i++) {
        this.padrones = this.padrones.sort((a, b) => { if (a.fechaDeCarga < b.fechaDeCarga) { return 1 } else { return -1 } });
      }
      this.padronesFiltrados = this.padrones;

      if(!isScroll) {
        this.handleSpinner(false);
      } else {
        this.ocultarSpinnerScroll();
      }
    }
    catch (error) {
      this.messageService.showErrorMessage('Hubo un error al obtener los padrones. ' + error.description);
      this.handleSpinner(false);
    }
  }

  handleSpinner(load: boolean) {
    this.esperandoCarga = load;
    load ? this.spinner.show('spinnerGrafico') : this.spinner.hide('spinnerGrafico');
  }

  mostrarSpinnerScroll() {
    this.obteniendoDatosScroll = true;
  }

  ocultarSpinnerScroll() {
    this.obteniendoDatosScroll = false;
  }

  onScrollPadrones(){
    this.getPadrones(++this.page, true);
  }
}
